import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.616 12.926A1 1 0 0 0 21 13a1 1 0 0 0 .71-1.71l-9-9a1 1 0 0 0-1.42 0l-9 9a1.004 1.004 0 1 0 1.42 1.42L11 5.411V21a1 1 0 0 0 2 0V5.411l7.29 7.299a1 1 0 0 0 .326.216"
    />
  </svg>
);
export default SvgArrowUp;
